import { FristenContext } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/context/FristenContext';
import { useContext } from 'react';

export function useFristenContext() {
  const context = useContext(FristenContext);
  if (!context) {
    throw new Error(
      'useFristenContext must be used within a FristenContextProvider',
    );
  }
  return context;
}
